export const SUPPORTED_LANGUAGES = ["en", "it"] as const
export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES[0]
export const DEFAULT_LOCALE = "it"
